// Office Bearers
export const officeBearers = [
  {
    name: "Sudarshan Mantri",
    position: "President",
    photo: "/photos/sudharshan.png",
    photoPosition: "top",
  },
  {
    name: "Kushal Maheswari",
    position: "Secretary",
    photo: "/photos/kushal.png",
    photoPosition: "top",
  },
  {
    name: "Hemanth Bhathad",
    position: "Vice President",
    photo: "/photos/hemanth.png",
    photoPosition: "center 15%",
  },
  {
    name: "Ketan Bisani",
    position: "Vice President",
    photo: "/photos/ketan.png",
    photoPosition: "center 25%",
  },
  {
    name: "Mohit Bajaj",
    position: "Treasurer",
    photo: "/photos/mohit.png",
    photoPosition: "center 20%",
  },
  {
    name: "Shubham Sarda",
    position: "Joint Secretary",
    photo: "/photos/shubham.png",
    photoPosition: "center 20%",
  },
  {
    name: "Nikhil Mohta",
    position: "Joint Secretary",
    photo: "/photos/nikhil.png",
    photoPosition: "center 20%",
  },
  {
    name: "Madan Mohan Rathi",
    position: "IPP",
    photo: "/photos/madan.png",
    photoPosition: "center 20%",
  },
  {
    name: "Pankaj Mohata",
    position: "IPS",
    photo: "/photos/pankaj.png",
    photoPosition: "center 20%",
  },
];

// Executive Committee Members
export const executiveMembers = [
  {
    name: "Abhinandan Chandak",
    position: "Executive Member",
    photo: "/photos/abhinandan.png",
    photoPosition: "center 5%",
  },
  {
    name: "Ankit Rathi",
    position: "Executive Member",
    photo: "/photos/ankit.png",
  },
  {
    name: "Arnav Maheswary",
    position: "Executive Member",
    photo: "/photos/arnav.png",
  },
  {
    name: "Arvind Kumar Jetha",
    position: "Executive Member",
    photo: "/photos/arvind.png",
  },
  {
    name: "Ashish Maheswari",
    position: "Executive Member",
    photo: "/photos/ashish.png",
    photoPosition: "center 20%",
  },
  {
    name: "Atul Maheswari",
    position: "Executive Member",
    photo: "/photos/atul.png",
    photoPosition: "center 20%",
  },
  {
    name: "Chirag Jhawar",
    position: "Executive Member",
    photo: "/photos/chirag.png",
    photoPosition: "center 20%",
  },
  {
    name: "Girish Singh Mohta",
    position: "Executive Member",
    photo: "/photos/girish.png",
    photoWebp: "/photos/girish.webp",
    photoPosition: "center 20%",
  },
  {
    name: "Jayesh Bisani",
    position: "Executive Member",
    photo: "/photos/jayesh-bisani.png",
    photoPosition: "center 10%",
  },
  {
    name: "Jayesh Rathi",
    position: "Executive Member",
    photo: "/photos/jayesh-rathi.png",
    photoPosition: "center 10%",
  },
  {
    name: "Kriti Suda",
    position: "Executive Member",
    photo: "/photos/kriti.png",
    photoPosition: "center 20%",
  },
  {
    name: "Laksh Kela",
    position: "Executive Member",
    photo: "/photos/laksh.png",
    photoPosition: "center 20%",
  },
  {
    name: "Mahima Rathi",
    position: "Executive Member",
    photo: "/photos/mahima.png",
  },
  {
    name: "Saakshi Chandak",
    position: "Executive Member",
    photo: "/photos/saakshi.png",
  },
  {
    name: "Tapas Bhattad",
    position: "Executive Member",
    photo: "/photos/tapas.png",
    photoPosition: "center 5%",
  },
  {
    name: "Vikramaditya Bisani",
    position: "Executive Member",
    photo: "/photos/vikramaditya.png",
    photoPosition: "center 15%",
  },
  {
    name: "Yash Malpani",
    position: "Executive Member",
    photo: "/photos/yash.png",
  },
  {
    name: "Yashika Malpani",
    position: "Executive Member",
    photo: "/photos/yashika.png",
    photoPosition: "center 20%",
  },
];

// Advisors
export const advisors = [
  {
    name: "Anurag Maheshwari",
    position: "Sabha Convener",
    photo: "/photos/anurag.png",
  },
  {
    name: "Hari Ratan Rathi",
    position: "Advisor",
    photo: "/photos/hari.png",
    photoPosition: "center 20%",
  },
  {
    name: "Jai Prakash Malpani",
    position: "Advisor",
    photo: "/photos/jaiprakash.png",
    photoPosition: "center 20%",
  },
  {
    name: "Praful Mohta",
    position: "Advisor",
    photo: "/photos/praful.png",
    photoPosition: "center 10%",
  },
  {
    name: "Pramod Sarda",
    position: "Advisor",
    photo: "/photos/pramod.png",
    photoPosition: "center 20%",
  },
  { name: "Vinod Dwarkani", position: "Advisor", photo: "/photos/vinod.png" },
];
